export default "__VITE_ASSET__DF5Y6GLY__"